import apiClient from './apiClient';
import { parseApiError } from '../utils/errorHelpers';

const deleteService = {
  async batchDeleteStudies(studyIds, reason = 'User manual deletion') {
    try {
      const response = await apiClient.post('/studies/batch-delete', {
        study_ids: studyIds,
        reason: reason,
      });

      const data = response.data;

      // Check if the operation failed completely or partially
      if (data.status === 'failed' && data.deleted_ids.length === 0) {
        // Complete failure - no studies were deleted
        const errorMessage = data.failed?.[0]?.error || 'Failed to delete studies';
        return {
          success: false,
          error: errorMessage,
        };
      }

      // Success (either full or partial)
      return {
        success: true,
        data: data,
      };
    } catch (error) {
      console.error('Batch delete failed:', error);
      const errorMessage = parseApiError(
        error,
        'Failed to delete studies. Please try again.'
      );

      return {
        success: false,
        error: errorMessage,
      };
    }
  },
};

export default deleteService;